import { registerCourt } from "../staticData/registerCourtOptions/registerCourt";

export const formatRegisterCourt = (value?: string | null): string => {
  if (!value) return "";

  const fullValue = registerCourt.find((option) => option.value === value)?.label;
  return fullValue ?? value;
};
